<!--  -->
<template>
  <div>
    <!-- <section class="breadcrumb-area breadcrumb-area2">
      <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="breadcrumb-content">
                    <p class="breadcrumb__meta"><span class="seller-badge"> 北京  &nbsp;&nbsp;&nbsp;{{course.addtime}}</span></p>
                    <h2 class="breadcrumb__title">{{course.title}}</h2>
                    <ul class="breadcrumb__list">
                        <li>讲师： <router-link :to="`/views/${plateid}`">{{course.author}}</router-link></li>
                        <li>
                            <i :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></i>
                            <i :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></i>
                            <i :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></i>
                            <i :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></i>
                            <i :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></i>
                           
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
      </div>
    </section> -->
     <section class="course-details-section" style="background:rgba(239, 243, 255, .32);">
        <div class="container">
            <div style="display:flex;">
              <div class="sc-thumb" style="padding: 0px;">
                  <img :src="`${global.remoteIp}/uploads/${course.picsrc}`" :style="`width: 100%;height:${CourseImgHigh}`"  ref="CourseImg" alt="">
              </div>
                <div class="single-course-area" style="width: 669px;">
                    <div class="course-top">
                        <h4>{{ course.title }}</h4>
                        <h6>辅导时间焚枯食淡回风口凤凰首府肯定是开发贷款v出发</h6>
                        <div class="course-meta">
                            <div class="author">
                                <img src="/static/images/jiaoshi.png" alt="">
                                <!-- <span>讲师:</span> -->
                                <router-link :to="`/views/${plateid}`">{{ course.author }}</router-link>
                                <span class="tip">大学教授</span>
                            </div>
                            <div class="categories">
                                <span style="color: #4A576A;">所属科目：</span>
                                <span style="color: #000000;"> {{ course.type }}</span>
                            </div>
                            <div class="categoriesex">
                                <span style="color: #4A576A;">时长：{{course.totalTime}}小时</span>
                                
                            </div>
                              <div class="course-price" >
                              {{ course.students ? course.students : 0 }}人报名
                          </div>
                        </div>
                    </div>
                    <a href="javascript:;" class="bisylms-btn" :style="course.isBuy == 1 ? 'background-color: #949594;' : ''" type="button" @click="showTearch()">报名学习</a>
                </div>
            </div>
        </div>
      </section>
    <section class="course-details-section">
      <div class="container">
          <div class="row">
              <div class="col-lg-9">
                  <div class="single-course-area" style="padding-left: 0">
                       <div class="course-tab-wrapper">
                        <ul class="course-tab-btn nav nav-tabs">
                            <li><a href="#overview" data-toggle="tab"><i class="icon_book_alt"></i>课程简介</a></li>
                            <li><a href="#curriculum" data-toggle="tab" class="active"><i class="icon_ribbon_alt"></i>课程目录</a></li>
                            <!-- <li><a class="active" href="#instructors" data-toggle="tab"><i class="icon_profile"></i>Instructors</a></li> -->
                            <!-- <li><a href="#reviews" data-toggle="tab"><i class="icon_star"></i>课程评分</a></li> -->
                        </ul>
                        <!-- Tab Content -->
                        <div class="tab-content">
                            <!-- Overview Tab -->
                            <div class="tab-pane fade in" id="overview" role="tabpanel">
                              课程简介
                                <div class="overview-content" v-html="course.description">
                                  
                                </div>
                            </div>
                            <!-- Overview Tab -->
                            <!-- Curriculum Tab -->
                            <div class="tab-pane fade in show active" id="curriculum" role="tabpanel">
                                <div class="curriculum-item"   v-for="(Class, index) in course.classes" :key="index" :id="`id_${index + 1}`">
                                    <!-- <div class="card-header" :id="`cc_${index+1}`">
                                      <h5 class="mb-0">
                                          <button class="btn btn-link" data-toggle="collapse" :data-target="`#acc_${index+1}`" :aria-expanded="index==0?'true':''" :aria-controls="`acc_${index}`">
                                              {{Class.title}}
                                          </button>
                                      </h5>
                                  </div> -->
                                    <div :id="`acc_${index + 1}`" class="collapse show" :aria-labelledby="`cc_${index + 1}`" :data-parent="`#id_${index + 1}`">
                                        <div class="card-body">
                                            <div   v-for="(video, indexex) in Class.videos" :key="indexex" :class="`ci-item ${indexex % 2 != 0 ? 'with-bg' : ''}`" @click="showVideo(video, indexex)">
                                                <h5>
                                                    <i class="icon_book_alt"></i>
                                                    <a>{{ video.info.title }}</a>
                                                </h5>
                                                <div class="ci-tools">
                                                    <a  class="time">{{ parseInt((parseFloat(video.info.time) * 60)) }} 分钟</a>
                                                    <!-- <a  class="lock" style="color: inherit !important;"><i :class="course.isBuy==1?'icon_lock-open_alt':'icon_lock_alt'"></i></a> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
              <div class="col-lg-3">
                <div class="course-sidebar">
                    <aside class="widget" v-if="!$root.onlymycourse">
                      <div class="info-course">
                      <div class="info__divider"></div>
                        <h3 class="courseinfot">相关课程</h3>
                        <div class="latest-course"  v-for="(course,index) in newCourse" :key="index">
                            <router-link :to="`/courview/info/${course._id}`"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt="">
                            <h5>{{course.title}}&nbsp;|&nbsp;{{ course.author }}直播</h5>
                            <div class="course-price">
                              {{ course.totalClass }}人参加

                            </div>
                            </router-link>
                        </div>
                      </div>
                    </aside>
                </div>
            </div>
          </div>
      </div>
    </section>
<el-dialog
    :title="`正在学习: ${video.title}`"
    :visible.sync="dialogVisible"
    :width="global.isPhone()? '95%':'50%'"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <el-divider></el-divider> 
    <div class="player-container" ref="VideoPlay" style="height:auto">
        <!-- <vue-core-video-player :autoplay="false"  :cover="`${global.remoteIp}/uploads/${video.picsrc}`" :src="`${global.remoteIp}/videoplay/${video.videosrc}?courseid=${course._id}`" :controls="auto"></vue-core-video-player> -->
        <!-- <LivePlayer :cover="`${global.remoteIp}/uploads/${video.picsrc}`"  :videoUrl="videoSrc" fluent autoplay hide-stretch-button></LivePlayer> -->
      <el-image v-if="video.isAudio"  :style="`width: 100%;height:${elImageHigh}`" :src="`${global.remoteIp}/uploads/${video.picsrc}`" ref="elImage"></el-image>
      <audio v-if="video.isAudio"
        style="width: 100%;"
        :src="videoSrc" controls="controls">
      Your browser does not support the audio element.
      </audio>
      <video-play v-else-if="videoSrc" :options="{url:videoSrc}" :style="`height:${videoHigh}`"/>
    </div>
    <span slot="footer" class="dialog-footer">
  </span>
</el-dialog>
<el-dialog
  :visible.sync="payInfoVisible"
  :width="global.isPhone()? '90%':'30%'"
  center
  >
  <el-descriptions title="订单信息" :column="1" border>
    <el-descriptions-item label="课程名称">{{payInfoCourse.title}}</el-descriptions-item>
    <el-descriptions-item label="课程讲师">{{payInfoCourse.author}}</el-descriptions-item>
    <el-descriptions-item label="课程科目">{{payInfoCourse.type}}</el-descriptions-item>
    <el-descriptions-item label="课程价格">{{payInfoCourse.price}}</el-descriptions-item>
  </el-descriptions>
  <span slot="footer" class="dialog-footer">
    <el-button @click="payInfoVisible = false; cancelPay()" >取 消</el-button>
    <el-button type="primary" @click="payInfoVisible = false;creatOrder()" >线上支付</el-button>
    <el-button type="primary" @click="payInfoVisible = false;showTearch()" >线下支付</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
// import LivePlayer from '@liveqing/liveplayer'
import VideoPlay from '../components/PublicComs/VideoPlay.vue';
import { Message } from "element-ui";
export default {
  data() {
    return {
      course: {},
      subjects: [],
      newCourse: [],
      global,
      options: {
        i18n: {
          speed: "速度",
          normal: "正常",
        },
      },
      video: {},
      dialogVisible: false,
      payInfoCourse:{},
      payInfoVisible:false,
      videoSrc: "",
      videoHigh:0,
      commentMsg:"",
      comments: [],
      intTotal:0,
      commentStars:0,
      plateid:"",
      isCourseStar:false,
      StarRate:{
        '1': "0",
        '2': "0",
        '3': "0",
        '4': "0",
        '5': "0",
      },
      elImageHigh:"",
      CourseImgHigh:""
    };
  },
  props: {
    plates: Array,
  },
  components: { VideoPlay },

  computed: {},

  mounted() {
   
    let courseId = this.$route.params.id;
    this.$axios.get(`/api/courses/visitor/${courseId}`).then((res) => {
      if (res.data) {
        this.course = res.data.data;
        this.isCourseStar = this.course.isCourseStar;
        if (!this.course.addtime) {
          let addtime = this.course.createdAt;
          let date = new Date(addtime);
          this.course.addtime = `${date.getFullYear()}-${(
            "00" +
            (date.getMonth() + 1)
          ).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${(
            "00" + date.getHours()
          ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
            "00" + date.getSeconds()
          ).slice(-2)}`;
        }
        // this.course.stars = this.course.courseStarAvg[0].avgStar;
        let totalStars=0;
        for(let i =0 ; i < this.course.courseStarGroup.length;i++) {
          totalStars += this.course.courseStarGroup[i].count;
        }
        for(let i =0 ; i < this.course.courseStarGroup.length;i++) {
          let id= this.course.courseStarGroup[i]._id;
          this.StarRate[id.toString()] =((this.course.courseStarGroup[i].count/totalStars)*100).toFixed(2);
        }
        this.$nextTick(function(){
          //this.CourseImgHigh = (this.$refs.CourseImg.clientWidth)*0.5625 + "px";
        })
      }
    });
    
     if(!this.$root.onlymycourse)
      {
          this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.newCourse = res.data.data;
        }
      });
      }
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.subjects = res.data.data;
      }
    });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
    const isLogin = localStorage.eleTokenWrd001 ? true : false;
    if(isLogin)
    {
    this.timer=setInterval(()=>{
        this.$axios.get("/api/auth/me").then(res => {
          const { token } = res.data;
          localStorage.setItem("eleTokenWrd001", token);
          // 解析token
          const decode = jwt_decode(token);
          // 存储数据
          this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
          this.$store.dispatch("setUser", decode);
           let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.$root.hasCourse =arrhasCourse;
        })
      },1000*60*10);
    this.$axios
      .get(`/api/courseComments/user?courseid=${courseId}&limit=5&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.comments = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    }
    
  },

  methods: {
    toPage(intcount) {
       this.$axios
        .get(
          `/api/courseComments/user?page=${
            intcount
          }&limit=5&sort=-createdAt&courseid=${this.course._id}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.comments = res.data.data;
          }
        });
    },
    showVideo(video,indexex,index) {
      let content;
      if(indexex==0&&index==0)
      {
        content = {
          confirmButtonText: '立即报名',
          cancelButtonText: '试看',
          type: 'warning'
        }
      }else{
        return
      }
      
      if(this.course.isBuy!=1&&this.course.price!=0) {
       var strTip = "该课程为未报名观看，是否立即报名学习?";
        if(this.course.isBuy==2)
        {
          strTip = "该课程已到期，是否重新报名学习?";
        }
        this.$confirm(strTip, '提示', content).then(() => {
          this.enterPay();
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // });        
           this.video = video.info;
            //this.videoSrc=`${this.global.remoteIp}/videoplay/${this.video.videosrc}?courseid=${this.course._id}`
            this.videoSrc=this.video.videosrc;
            this.dialogVisible = true;
            this.$nextTick(function(){
                this.videoHigh = (this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
                this.elImageHigh =(this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
              })  
        });
      }else{
        this.video = video.info;
            //this.videoSrc=`${this.global.remoteIp}/videoplay/${this.video.videosrc}?courseid=${this.course._id}`
            this.videoSrc=this.video.videosrc;
            this.dialogVisible = true;
            this.$nextTick(function(){
                this.videoHigh = (this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
                this.elImageHigh =(this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
              })  
      }
     
    },
    showTearch(){
      this.$alert('您可以联系赵老师，联系电话：0000-0000', '线下支付', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
          }
        });
    },
    handleClose() {
      this.videoSrc="";
      this.dialogVisible = false;
    },
    creatOrder(){
      const loading = this.$loading({
          lock: true,
          text: '正在创建订单，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.global.isPhone()?
      this.$axios.post(`/api/zfb/createOrder_m`,{
        payName:"购买在线课程",
        goodsName:"在线课程-"+this.course.title,
        count:1,
        goodsId:this.course._id,
        returnHtml:"<script> + window.open('" + this.global.remoteIp + "/courview/info/"+this.course._id+"','_self') <\/script>"
      }).then((res) => {
         // loading.close();
           const div=document.createElement('divform');
          div.innerHTML=res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
      }).catch((e) => {
        loading.close();
      })
      :
      this.$axios.post(`/api/zfb/createOrder_pc`,{
        payName:"购买在线课程",
        goodsName:"在线课程-"+this.course.title,
        count:1,
        goodsId:this.course._id,
        returnHtml:"<script> + window.open('" + this.global.remoteIp + "/courview/info/"+this.course._id+"','_self') <\/script>"
      }).then((res) => {
        //loading.close();
           const div=document.createElement('divform');
          div.innerHTML=res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
      }).catch((e) => {
        loading.close();
      });
    },
    cancelPay(){
      this.payInfoCourse = {};
    },
    enterPay(){
      if(this.course.isBuy!=1&&this.course.price!=0)
      {
        this.$axios.get(`/api/zfb/payinfo/?_id=${this.course._id}`).then((res) => {
          this.payInfoCourse = res.data.data;
          this.payInfoVisible = true;
        });
      }
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    submitComment(){
      if(!this.commentMsg)return;
      this.$axios.post(`/api/courseComments/user`,{
        courseid:this.course._id,
        comment: this.commentMsg
      }).then((res) => {
         if(res&&res.data){
           Message.success("评论成功");
           this.commentMsg="";
           this.toPage(0)
         }
      })
    },
    commitStars(){
       this.$axios.post(`/api/courseStars/user`,{
        courseid:this.course._id,
        stars: this.commentStars
      }).then((res) => {
         if(res&&res.data){
           Message.success("评分成功");
           this.isCourseStar = true;
         }
      })
    }
  },
};
</script>
<style scoped>
/deep/ .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 0px;
}
/deep/ .el-dialog__body {
  padding: 5px 20px 30px 20px;
}
/deep/ .el-dialog__title {
  color: #233d63;
  font-size: 29px;
  line-height: 33px;
  font-weight: 500;
}
.la{
  color: #F68A03;
}
.la-globe{
  color: #F68A03;
}
.breadcrumb-area2{
  background: url('/static/images/bg_001.png') repeat-x  top;
  margin:  auto;
  margin-top: 11px;
  width: 1200px;
  height: 270px;
}
.breadcrumb-content{
  margin: 60px 66px;
}
.seller-badge{
  font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.breadcrumb__title{
  font-size: 36px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
        line-height: 63px;
}
.breadcrumb__list{
      font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.breadcrumb__list a{
      font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}


/*--------------------------------------------------------
/ 11. Course Details Page
/---------------------------------------------------------*/
.course-details-section {
    position: relative;
    padding: 56px 0;
}

.course-details-section .course-sidebar .widget {
   width: 303px;
height: 441px;
background: #FDFDFD;
box-shadow: 0px 2px 14px 0px rgba(120,120,120,0.11);
border-radius: 10px;
}

.info-course {
    position: relative;
    padding: 17px 16px;
}

.info-course ul {
    margin: 0;
    padding: 0;    
    border-top: 1px solid #E6E6E6;
    margin-top: 14px;
}

.info-course li {
    list-style: none;
    display: inline-block;
    width: 100%;
    font-size: 14px;
    line-height: 40px;
    color: #5d5a67;
    font-weight: 400;
    margin: 0;
    padding: 0 0 1px;
}

.info-course li:last-child {
    border: none;
}

.info-course li i {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
}

.info-course li span {
    display: inline-block;
    font-weight: 600;
    font-size: 14px;
font-family: PingFang SC;
font-weight: 600;
color: #333333;
}

.info-course .bisylms-btn {
      width: 227px;
    height: 40px;
    background: #4282CA;
    border-radius: 3px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: center;
    color: #FFFFFF;
    line-height: 40px;
}

.single-course-area {
    position: relative;
    padding-left:32px;
}

.course-top {
    position: relative;
    margin: 0 0 82px;
}

.course-top h4 {
  margin-top:25px;
  margin-bottom:25px;
   width: 242px;
height: 32px;
font-size: 32px;
font-family: PingFang SC;
font-weight: bold;
color: #000000;
line-height: 32px;
 -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.course-top h6{
  margin-bottom:25px;
width: 483px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #4A576A;
line-height: 18px;
   -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}

.course-top .course-price {
    position: absolute;
    right: 0;
    top: 0;
    margin: 0 0;
    padding: 0 22px 0;
    font-weight: 700;
    height: 32px;
    background: #DBE2FF;
    border-radius: 5px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #4462CF;
    text-align: center;
    line-height: 32px;
}

.course-top .course-price span {
    font-size: 14px;
    font-weight: 600;
    color: #7e7c87;
    display: block;
    margin: 0 0;
}
.bisylms-btn{
  display: block;
  width: 297px;
height: 56px;
background: #4462CF;
border-radius: 10px;
font-size: 20px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
line-height: 56px;
text-align: center;
}

.course-meta {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 56px;
}

.course-meta .author {
    position: relative;
    display: flex;
    justify-content: start;
    align-items: center;
}

.course-meta .author img {
    width: 56px;
    height: 56px;
}
.course-meta .author span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
}

.course-meta .author a {
  width: 80px;
    padding: 0 10px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #4A576A;
}

.categories {
    margin: 0 0 0 30px;
}

.categories span {
    font-size: 16px;
    line-height: 20px;
    margin: 0 0 4px;
    font-family: PingFang SC;
    font-weight: bold;
}

.categories a {
    display: block;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
}

.categoriesex {
    padding-left: 33px;
}

.categoriesex span {
    display: block;
    width: 102px;
    height: 40px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #4A576A;
    line-height: 40px;
}

.categoriesex a {
    display: block;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
}
.course-meta .ratings {
    display: block;
    margin: 0 0;
}

.course-meta .ratings span {
    /* display: block; */
    margin: 0 0 -4px;
    line-height: 20px;
    color: #7e7c87;
}

.course-meta .author a:hover,
.categories a:hover {
    color: #4282CA;;
}

.blog-content img {
    width: 100%;
}

.sc-thumb img {
   width: 499px;
height: 329px;
background: #EFF3FF;
border-radius: 15px;
}

.course-tab-wrapper {
    position: relative;
  width: 877px;
min-height: 602px;
background: #FFFFFF;
box-shadow: 0px 2px 14px 0px rgba(120,120,120,0.11);
border-radius: 20px;
    overflow: hidden;
}

.course-tab-btn {
    display: flex;
    justify-content: space-around;
    width: 100%;
    border: none;
}

.course-tab-btn li {
    list-style: none;
    margin: 0;
    width: 50%;
}

.course-tab-btn li a {
    display: inline-block;
    width: 100%;
    text-align: center;
    background: #f7f8fa;
    position: relative;
    font-size: 20px;
    line-height: 55px;
    height: 55px;
    color: #333333;
    font-weight: 600;
}

.course-tab-btn li a i {
    font-size: 20px;
    position: relative;
    top: 2px;
    margin-right: 6px;
}

.course-tab-btn li a.active,
.course-tab-btn li a:hover {
    color: #4462CF;;
    background: #fff;
}

.course-tab-btn li a.active:after,
.course-tab-btn li a:hover:after {
    width: 100%;
}

.course-tab-btn li:last-child a {
    border-right: none;
}

.course-tab-wrapper .tab-content {
    position: relative;
}

.teacher-item-3 {
    position: relative;
    margin: 0 0 30px;
    width: 100%;
    min-height: 280px;
    padding-left: 300px;
}

.teacher-item-3 .teacher-thumb {
    background: transparent;
    position: absolute;
    left: 0;
    top: 0;
    width: 260px;
    height: 280px;
}

.teacher-item-3 .teacher-thumb img {
    width: 100%;
    height: 100%;
}

.teacher-item-3 .teacher-meta {
    padding: 35px 0 0;
}

.teacher-item-3 .teacher-meta h5 a:hover {
    color: #4282CA;;
}

.teacher-item-3 .teacher-meta span {
    display: block;
    font-size: 14px;
    color: #797682;
    font-weight: 600;
    margin: -6px 0 16px;
}

.teacher-item-3 .teacher-meta p {
    font-size: 14px;
    line-height: 24px;
    color: #5d5a67;
    font-weight: 400;
    margin: 0 0 27px;
}

.teacher-item-3 .teacher-social {
    position: relative;
    bottom: auto;
    transform: none;
    text-align: left;
}

.teacher-item-3 .teacher-social a {
    color: #7e7c87;
    line-height: 40px;
    margin: 0 3px;
    border: 2px solid #e5e6eb;
}

.teacher-item-3 .teacher-social a:hover {
    color: #ffffff;
    background: #4282CA;;
    border-color: #4282CA;;
    -webkit-box-shadow: 0px 10px 20px 0px rgba(9, 111, 150, 0.30);
    -moz-box-shadow: 0px 10px 20px 0px rgba(9, 111, 150, 0.30);
    box-shadow: 0px 10px 20px 0px rgba(9, 111, 150, 0.30);
}

.overview-content {
    position: relative;
}

.overview-content h4 {
    font-size: 20px;
    margin: 0 0 18px;
}

.overview-content p {
    font-size: 14px;
    line-height: 26px;
    margin: 0 0 26px;
}

.overview-content ul {
    margin: 0;
    padding: 10px 0 0;
}

.overview-content ul li {
    list-style: none;
    position: relative;
    padding-left: 40px;
    font-size: 16px;
    line-height: 30px;
    font-weight: 600;
    color: #2c234d;
    margin: 0 0 24px;
}

.overview-content ul li i {
    position: absolute;
    left: 0;
    top: 0;
    color: #4282CA;;
    font-size: 20px;
    line-height: 35px;
}

.overview-content ul li span {
    display: block;
    color: #5d5a67;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    margin: 14px 0 0;
}

.curriculum-item {
    position: relative;
}
.curriculum-item:nth-child(2n){
background: #F7F8FA;
}
.curriculum-item .card-header {
    padding: 23px 30px;
    margin: 0;
    background: transparent;
    border: none;
    border-radius: 0;
}

.curriculum-item h5 {
    color: #2c234d;
    font-size: 16px;
    line-height: 24px;
    margin: 0 0 0;
}

.curriculum-item h5 button {
    text-decoration: none;
    margin: 0;
    padding: 0;
    display: inline-block;
    font-weight: inherit;
    color: inherit;
    text-align: inherit;
    vertical-align: inherit;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background: transparent;
    border: none;
    width: 100%;
    font-size: inherit;
    line-height: inherit;
    border-radius: 0;
}

.curriculum-item h5 button:after {
    content: "\E6DF";
        font-family: element-icons!important;
    display: inline-block;
    font-size: 24px;
    line-height: 70px;
    font-weight: 500;
    color: #4282CA;;
    position: absolute;
    right: 27px;
    top: 0;
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.curriculum-item h5 button:hover {
    text-decoration: none;
    color: inherit;
}

.curriculum-item h5 button.collapsed:after {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.curriculum-item .card-body {
    margin: 0;
    padding: 0;
}

.ci-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 18px 30px 12px;
    line-height: 35px;
}

.ci-item:last-child {
    border-radius: 0 0 10px 10px;
}

.ci-item h5 {
    font-size: 16px;
    color: #5d5a67;
    font-weight: 400;
    list-style: 24px;
    margin: 0;
}

.ci-item h5 i {
  position: relative;
    display: inline-block;
    color: #4282CA;;
    margin-right: 16px;
    top:2px;
    line-height: 35px;
}

.ci-item h5 a {
    color: inherit;
height: 16px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #181818;
line-height: 35px;
}

.ci-item h5:hover a {
    color: #4462CF;
}

.ci-tools a {
    display: inline-block;
    position: relative;
    margin-left: 10px;
}

.ci-tools .time {
    
background: #EBEFFF;
    color: #3F3F3F;;
    border-radius: 3px;
    height: 35px;
    text-align: center;
    font-size: 16px;
    line-height: 35px;
    font-weight: 600;
    padding: 0 16px;
}

.ci-tools .time:hover {
    background: #4462CF;
    color: #fff;
}

.ci-tools .lock {
    font-size: 14px;
    line-height: 30px;
    color: #5d5a67;
}

.ci-tools .lock:hover {
    color: #4282CA;;
}

.ci-item.with-bg {
    background: #f7f8fa;
}

.ci-tools .questions {
    background: rgb(101, 16, 173, 0.1);
    color: #4282CA;;
    border-radius: 3px;
    height: 30px;
    text-align: center;
    font-size: 13px;
    line-height: 30px;
    font-weight: 600;
    padding: 0 16px;
}

.ci-tools .questions:hover {
    background: #4282CA;;
    color: #fff;
}

.reviw-area {
    position: relative;
}

.reviw-area h4 {
    font-size: 20px;
    margin: 0 0 26px;
}

.reating-details {
    position: relative;
    display: flex;
    justify-content: flex-start;
    margin: 0 0 78px;
}

.average-rate {
    width: 26%;
}

.average-rate p {
    font-size: 14px;
    line-height: 28px;
    color: #5d5a67;
    margin: 0 0 15px;
}

.rate-box {
    width: 100%;
    height: 200px;
    background: #f7f8fa;
    border-radius: 5px;
    text-align: center;
    padding: 34px 15px;
}

.rate-box h2 {
    font-size: 60px;
    color: #4282CA;;
    line-height: 60px;
    margin: 0 0 18px;
}

.rate-box .ratings {
    display: block;
    margin: 0 0 3px;
}

.rate-box .ratings i {
    font-size: 14px;
}

.rate-box .ratings i:last-child {
    color: #c4c2cb;
}

.rate-box span {
    /* display: block; */
    font-size: 14px;
    line-height: 24px;
    color: #5d5a67;
}

.details-rate {
    position: relative;
    width: 74%;
    margin-left: 30px;
}

.details-rate p {
    font-size: 14px;
    line-height: 28px;
    color: #5d5a67;
    margin: 0 0 15px;
}

.detail-rate-box {
    width: 100%;
    height: 200px;
    background: #f7f8fa;
    border-radius: 5px;
    padding: 36px 40px;
}

.rate-item {
    position: relative;
    padding-left: 25px;
    padding-right: 55px;
    margin: 0 0 24px;
}

.rate-item p {
    position: absolute;
    left: 0;
    top: -3px;
    font-size: 14px;
    line-height: .8;
    color: #2c234d;
    font-weight: 600;
    margin: 0;
}

.rate-item .progress {
    height: 6px;
    border-radius: 30px;
    background: #e1e4eb;
}

.rate-item .progress-bar {
    background: #4282CA;;
    border-radius: 30px;
}

.rate-item span {
    position: absolute;
    right: 0;
    top: -3px;
    color: #7e7c87;
    font-size: 14px;
    line-height: .8;
    font-weight: 600;
}

.review-rating {
    position: relative;
}

.review-rating>h5 {
    font-size: 20px;
    margin: 0 0 45px;
}

.review-rating ol {
    margin: 0;
    padding: 0;
}

.review-rating ol li {
    list-style: none;
    display: block;
}

.single-comment .ratings {
    margin: 0;
    position: absolute;
    right: 0;
    top: 4px;
}

.single-comment .ratings span {
    color: #c4c2cb;
    display: inline-block;
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: 0;
}

.single-comment .ratings span i {
    color: #c4c2cb;
}

.review-form-area {
    position: relative;
}

.review-form-area>h5 {
    font-size: 20px;
    margin: 0 0 25px;
}

.comment-form-rating {
    display: flex;
    justify-content: flex-start;
    margin: 0 0;
}

.comment-form-rating label {
    font-size: 14px;
    line-height: 28px;
    font-weight: 400;
    color: #5d5a67;
    margin: 0;
}

.comment-form-rating .ratings {
    margin-left: 15px;
}

.comment-form-rating .ratings span {
    line-height: .8;
    font-size: inherit;
    color: inherit;
    margin: 0;
}

.comment-form-rating .ratings span i {
    color: #c4c2cb;
}

.single-course-area .post-share {
    border: none;
}

.related-course {
    position: relative;
    margin: 72px 0 0;
}

.related-course h3 {
    font-size: 30px;
    margin: 0 0 43px;
}

.related-course-slider.owl-carousel {
    position: relative;
}

.related-course-slider.owl-carousel .owl-dots {
    position: relative;
    line-height: .8;
    margin: 0;
    text-align: center;
}

.related-course-slider.owl-carousel .owl-dots button {
    width: 10px;
    height: 10px;
    background: #dad7e3;
    border-radius: 50%;
    margin: 0 5px;
    -webkit-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.related-course-slider.owl-carousel .owl-dots button.active,
.related-course-slider.owl-carousel .owl-dots button:hover {
    background: #4282CA;;
}

.related-course-slider.owl-carousel .owl-dots button span {
    display: none;
}

.related-course-slider.owl-carousel .owl-stage-outer {
    margin: 0 -20px;
    padding: 0 20px;
}

.related-course-slider.owl-carousel .fci-details .author img {
    display: inline-block;
}
.info__divider{
    width: 5px;
height: 21px;
background: #4462CF;
border-radius: 3px;
    display: inline-block;
    float: left;
}
.courseinfot{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 20px;
  margin-left: 13px;
}
.icon{
  width: 20px;
    height: 20px;
    margin-right: 12px;
    position: relative;
    top: 6px;
        background-repeat: no-repeat;
}
.icon_house_alt{
      background-image: url(/static/images/icon_js.png);
    
}
.icon_document_alt{
  background-image: url(/static/images/icon_ks.png);
}
.icon_clock_alt{
  background-image: url(/static/images/icon_ks.png);
}
.icon_profile{
background-image: url(/static/images/icon_4.png);
}
.icon_cog{
  background-image: url(/static/images/icon_5.png);
}
.icon_calendar{
  background-image: url(/static/images/icon_ks.png);
}

/deep/ .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 0px;
}
/deep/ .el-dialog__body {
  padding: 5px 20px 30px 20px;
}
/deep/ .el-dialog__title {
  color: #233d63;
  font-size: 29px;
  line-height: 33px;
  font-weight: 500;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
/deep/ .el-pager li.active {
  color: #51be78;
}
.la{
  color: #F68A03;
}
.la-globe{
  color: #F68A03;
}

audio::-webkit-media-controls {
  overflow: hidden !important
}
/* audio::-webkit-media-controls-enclosure {
    margin-left: auto;
} */
/deep/ .audio__play-rate{
  display: none;
}
/deep/ .audio__progress-point{
  display: none !important;
}
/deep/ .audio__play-icon{
  color: #000 !important;
}
/deep/ .audio__play-volume{
  background-color: #000 !important;
}
/deep/ ..audio-player .audio__progress-wrap{
  margin-top: 5px !important;
}

span.tip{
  padding: 0;
  width: 69px;
height: 21px;
background: #00D57A;
border-radius: 3px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
line-height: 21px;
color: #FFFFFF !important;
text-align: center;
}
.latest-course{
  margin: 25px 0;
}
.latest-course img{
  width: 101px;
height: 70px;
background: #5D7AF2;
border-radius: 3px;
}
.latest-course{
  padding-left:111px;
}
.latest-course h5 {
  width: 163px;
height: 37px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #2F3D59;
line-height: 19px;
 overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.latest-course .course-price{
  margin-top: 12px;
  padding-left: 34px;
height: 23px;
font-size: 13px;
font-family: PingFang SC;
font-weight: 500;
color: #ACADB0;
line-height: 23px;
background-image:url(/static/img/yanji.png);
background-repeat: no-repeat;
background-position: left center;
background-size: 23px auto;
}
</style>
